var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66797 5.8335L8.47205 10.5963C9.02305 10.9821 9.29855 11.1749 9.59822 11.2496C9.86289 11.3156 10.1397 11.3156 10.4044 11.2496C10.7041 11.1749 10.9796 10.9821 11.5306 10.5963L18.3346 5.8335M5.66797 16.6668H14.3346C15.7348 16.6668 16.4348 16.6668 16.9696 16.3943C17.4401 16.1547 17.8225 15.7722 18.0621 15.3018C18.3346 14.767 18.3346 14.067 18.3346 12.6668V7.3335C18.3346 5.93336 18.3346 5.2333 18.0621 4.69852C17.8225 4.22811 17.4401 3.84566 16.9696 3.60598C16.4348 3.3335 15.7348 3.3335 14.3346 3.3335H5.66797C4.26784 3.3335 3.56777 3.3335 3.03299 3.60598C2.56259 3.84566 2.18014 4.22811 1.94045 4.69852C1.66797 5.2333 1.66797 5.93336 1.66797 7.3335V12.6668C1.66797 14.067 1.66797 14.767 1.94045 15.3018C2.18014 15.7722 2.56259 16.1547 3.03299 16.3943C3.56777 16.6668 4.26784 16.6668 5.66797 16.6668Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4788069cc4508a40a2791734769eebf3.svg";
export { ForwardRef as ReactComponent };